module.exports = __webpack_public_path__ + "img/qfcm-img7.7081b77e.png";